module.exports = __webpack_public_path__ + "media/images/home-share-ee051c3a43019d4a710edbbd5da85ef5.jpg";